import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-alert-box',
  templateUrl: './icon-alert-box.component.html',
  styleUrls: ['./icon-alert-box.component.scss'],
  standalone: false,
})
export class IconAlertBoxComponent {
  @Input() tooltip?: string;
}
